'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var tooltip = require('../components/tooltip.js');
var accordion = require('../components/accordion.js');
var trimEquipmentList = require('../components/trim-equipment-list.js');
var engineList = require('../components/engine-list.js');
var derivativeList = require('../components/derivative-list.js');
var scrollableTabs = require('../components/scrollable-tabs.js');

var classNames = {
	toggler: 'specs-selection-page__glossary-panel__toggle',
	glossary: 'specs-selection-page__glossary-panel__content'
};

function initGlossaryToggle($context) {
	var toggler = $.findByBem(classNames.toggler, null, null, $context);

	toggler.on('click', function (e) {
		e.preventDefault();
		$.findByBem(classNames.glossary, null, null, $context).slideToggle();
	});
}

basePage.init = function () {
	var $context = $('#carDerivSpecsSelectionPage');
	var displayEngineDropDown = true;
	var actionTrimSelectedEvent = true;

	basePage.initBasePage();
	tooltip.init($context);
	accordion.init();
	trimEquipmentList.init($context, displayEngineDropDown, actionTrimSelectedEvent);

	engineList.init($context);
	derivativeList.init($context);

	trimEquipmentList.autoSelectSingleTrim();
	trimEquipmentList.autoSelectAssignedTrim();

	initGlossaryToggle($context);

	scrollableTabs.init();
};

module.exports = basePage;